import React, { Component } from "react";
import TabelaEmpresas from "./TabelaEmpresas";
import Swal from "sweetalert2";
import AppContext from "../../appContext";
import { update_concluir_cadastro, reverterAtualizacaoOEC } from "../../Functions/empresa/update-concluir-cadastro";
import { post_cadastro_essilor_promo } from "../../Functions/empresa/post-cadastro-essilor-promo";

const escaparHtml = texto => String(texto).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

class Pendente extends Component {
  static contextType = AppContext;

  constructor() {
    super();
    this.state = {
      empresasAtualizadas: [],
    };
    this.tabelaRef = null;
  }

  setTabelaRef = (ref) => {
    this.tabelaRef = ref;
  };

  componentDidMount() {
    this.atualizarEmpresas();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.payload !== this.props.payload) {
      this.atualizarEmpresas();
    }
  }

  atualizarEmpresas = () => {
    const emEdicao = new Map(this.state.empresasAtualizadas.map(item => [item.usuario?.Id, item]));
    const empresasTransformadas = (this.props.payload || [])
      .filter(item => item.empresa && Array.isArray(item.empresa) && item.empresa.length > 0)
      .map(item => {
        return emEdicao.get(item.usuario?.Id) || {
          usuario: { ...item.usuario },
          empresa: item.empresa,
        };
      });

    this.setState({ empresasAtualizadas: empresasTransformadas });
  }

  /**
   * @param {number} index
   * @param {string} alvo
   * @param {string} campo
   * @param {any} valor
   */
  handleUpdate = (index, alvo, campo, valor) => {
    this.setState(prevState => {
      const novasEmpresas = [...prevState.empresasAtualizadas];
      if (alvo === "empresa" && novasEmpresas[index] && novasEmpresas[index].empresa && novasEmpresas[index].empresa[0]) {
        novasEmpresas[index] = {
          ...novasEmpresas[index],
          empresa: [{
            ...novasEmpresas[index].empresa[0],
            conta: {
              ...novasEmpresas[index].empresa[0].conta,
              [campo]: valor
            }
          }]
        };
      } else if (alvo === "usuario" && novasEmpresas[index]) {
        novasEmpresas[index] = {
          ...novasEmpresas[index],
          usuario: {
            ...novasEmpresas[index].usuario,
            [campo]: valor
          }
        };
      }
      return { empresasAtualizadas: novasEmpresas };
    });
  };

  /**
   * Atualiza múltiplos campos de uma vez (útil para atualização de CEP)
   * @param {number} index
   * @param {string} alvo
   * @param {object} campos - objeto com os campos e valores a atualizar
   */
  handleUpdateMultiple = (index, alvo, campos) => {
    this.setState(prevState => {
      const novasEmpresas = [...prevState.empresasAtualizadas];
      if (alvo === "empresa" && novasEmpresas[index] && novasEmpresas[index].empresa && novasEmpresas[index].empresa[0]) {
        novasEmpresas[index] = {
          ...novasEmpresas[index],
          empresa: [{
            ...novasEmpresas[index].empresa[0],
            conta: {
              ...novasEmpresas[index].empresa[0].conta,
              ...campos
            }
          }]
        };
      } else if (alvo === "usuario" && novasEmpresas[index]) {
        novasEmpresas[index] = {
          ...novasEmpresas[index],
          usuario: {
            ...novasEmpresas[index].usuario,
            ...campos
          }
        };
      }
      return { empresasAtualizadas: novasEmpresas };
    });
  };

  formatarCNPJ = (cnpj) => {
    if (!cnpj) return "";
    const clean = cnpj.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 14);
    let formatted = clean;
    if (clean.length > 2) formatted = clean.slice(0, 2) + "." + clean.slice(2);
    if (clean.length > 5) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5);
    if (clean.length > 8) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8);
    if (clean.length > 12) formatted = clean.slice(0, 2) + "." + clean.slice(2, 5) + "." + clean.slice(5, 8) + "/" + clean.slice(8, 12) + "-" + clean.slice(12);
    return formatted;
  };

  handleDecision = (acao, dados, index) => {
    // Se for aprovar, validar campos obrigatórios primeiro
    if (acao === "aprovar" && this.tabelaRef) {
      const isValid = this.tabelaRef.validateAllFields(index);
      if (!isValid) {
        Swal.fire({
          icon: "error",
          title: "Revise os campos do cadastro",
          text: "Preencha os campos obrigatórios e corrija os campos inválidos antes de aprovar.",
        });
        // Expandir a linha para mostrar os erros
        if (this.tabelaRef) {
          this.tabelaRef.setState({ expandedIndex: index });
        }
        return;
      }
    }

    const cnpjFormatado = this.formatarCNPJ(dados.conta.cnpj);
    const texto =
      acao === "reprovar"
        ? `Tem certeza que deseja <strong style="color: red;">reprovar</strong> o cadastro da empresa <strong>${cnpjFormatado}</strong>?`
        : `Tem certeza que deseja <strong style="color: green;">aprovar</strong> o cadastro da empresa <strong>${cnpjFormatado}</strong>?`;

    Swal.fire({
      html: `${texto}<br><br><strong>Observação da análise*</strong>`,
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Descreva a observação da análise",
      inputAttributes: { maxlength: "500" },
      inputValidator: value => {
        if (!value || !value.trim()) {
          return "O preenchimento da Observação é obrigatório.";
        }
        return null;
      },
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
      confirmButtonColor: acao === "aprovar" ? "#28a745" : "#dc3545",
    }).then(result => {
      if (result.value) {
        this.aprovacao(acao, index, result.value.trim());
      }
    });
  };

  async aprovacao(acao, index, observacao) {
    this.context.showLoading("Processando...");

    const statusAprovacao = acao === "aprovar";
    const empresaInfo = this.state.empresasAtualizadas[index].empresa;
    const usuarioInfo = this.state.empresasAtualizadas[index].usuario;

    const empresaAtualizada = empresaInfo.map(item => ({
      ...item,
      conta: {
        ...item.conta,
        statusCadastro: statusAprovacao ? "APROVADO" : "REPROVADO",
      }
    }));

    const payload = {
      empresa: empresaAtualizada,
      usuario: { ...usuarioInfo },
      atualizadoPor: this.context.userSession.email,
      observacao: observacao,
    };

    try {
      // 1. Atualiza o cadastro no OEC (transfere Conta Provisória para Conta e atualiza status)
      const resultOEC = await update_concluir_cadastro(payload, this.context.userSession.email);

      if (resultOEC === 400 || resultOEC?.success === false) {
        this.context.hideLoading();
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: `Houve um problema ao atualizar o cadastro no OEC.${resultOEC?.message ? ` Detalhe: ${resultOEC.message}` : ""}`,
        });
        return;
      }

      if (acao === "aprovar") {
        // 2. Cadastra a empresa no Essilor Promo (iPremios)
        const resultEssilorPromo = await post_cadastro_essilor_promo(empresaInfo[0]);

        if (resultEssilorPromo?.success === false) {
          const dadosRollback = resultOEC?.dados_para_rollback;
          if (dadosRollback) {
            await reverterAtualizacaoOEC(
              dadosRollback.userId,
              dadosRollback.cnpj,
              dadosRollback.contaProvisoria,
              this.context.userSession.email
            );
          }
          this.context.hideLoading();
          Swal.fire({
            icon: "error",
            title: "Erro",
            html: `Falha ao cadastrar no Essilor Promo: ${escaparHtml(String(resultEssilorPromo?.message || "Erro desconhecido").trim().replace(/\.+$/, ""))}.<br>A aprovação no OEC foi revertida.`,
          });
          return;
        }
      }

      const cadastroAnalisado = this.state.empresasAtualizadas[index];

      this.context.hideLoading();

      this.removerEmpresaDaLista(index);

      if (this.props.onAnalisado) {
        this.props.onAnalisado(cadastroAnalisado, statusAprovacao ? "APROVADO" : "REPROVADO");
      }

      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        html: acao === "aprovar"
          ? "Cadastro aprovado com sucesso. A empresa foi cadastrada no OEC e no Essilor Promo."
          : "Cadastro reprovado com sucesso.",
      });
    } catch (error) {
      console.error(error);
      this.context.hideLoading();
      Swal.fire("Erro", "Houve um problema ao processar a solicitação.", "error");
    }
  }

  removerEmpresaDaLista(index) {
    if (this.tabelaRef && this.tabelaRef.setState) {
      this.tabelaRef.setState({ expandedIndex: null, errors: {}, papeisPorIndex: {}, loadingCep: {}, modalsPorIndex: {} });
    }

    this.setState(prevState => {
      const novasEmpresas = [...prevState.empresasAtualizadas];
      novasEmpresas.splice(index, 1);
      return { empresasAtualizadas: novasEmpresas };
    });
  }

  render() {
    return <TabelaEmpresas onRef={this.setTabelaRef} dados={this.state.empresasAtualizadas} mostrarAcoes={true} handleDecision={this.handleDecision} onUpdate={this.handleUpdate} onUpdateMultiple={this.handleUpdateMultiple} />;
  }
}

export default Pendente;
